
















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {IDataTableHeader} from '@/types';
import BarcodeScanner from '@/components/BarcodeScanner.vue';

@Component({
  components: {BarcodeScanner},
})
export default class PasteBox extends Vue {

  private get source() {
    return this.header.queryKey;
  }
  @Prop() private header!: IDataTableHeader;
  @Prop() private headers!: IDataTableHeader[];
  @Prop() private showPasteBox!: any;
  @Prop() private filteredValues!: any;
  @Prop() private filterMenus!: any;
  private launchScanner: boolean = false;
  private nonce = 1;
  private search: string = '';
  private list: any = [];

  @Watch('filteredValues', {deep: true})
  public onFilterValuesChange(val: any, prev: any) {
    if (prev && val.length === prev.length) {
      return;
    }
    const openHeader = Object.entries(this.filterMenus).find(([header, value]) => value);
    if (openHeader) {
      const headerToFilterOn = this.headers.find((h) => h.value === openHeader[0]);
      const nameToIdMap: { [key: string]: number } = {};
      if (!headerToFilterOn || !headerToFilterOn.allowedFilterValues) {
        return;
      }
      headerToFilterOn.allowedFilterValues.forEach((item: any) => {
        nameToIdMap[item.name] = item.id;
      });
      this.list = val.map((v: any) => {
        if (typeof v === 'string') {
          v = {id: ++this.nonce, value: v, internalId: nameToIdMap[val], header: headerToFilterOn.value, queryKey: headerToFilterOn.queryKey };
        }
        return v;
      });
    }
    this.$emit('listUpdated', this.list);
  }

  private addPasteListener() {
    if (this.$refs['combobox_' + this.source]) {
      (this.$refs['combobox_' + this.source] as any).$el.addEventListener('paste', this.pasteListener);
    }
  }

  @Watch('showPasteBox')
  private removePasteListener() {
    this.$emit('filteringList', this.showPasteBox);

    if (this.$refs['combobox_' + this.source]) {
      (this.$refs['combobox_' + this.source] as any).$el.removeEventListener('paste', this.pasteListener);
    }
  }

  @Watch('list')
  private onListUpdate(val: any[], prev: any[] | undefined) {
    if (prev && val.length === prev.length) {
      return;
    }
    this.$emit('listUpdated', this.list);
    this.$emit('filtersDirtied', true);
  }

  private pasteListener(event: any) {
    if (event.clipboardData && event.clipboardData.getData('text') && event.clipboardData.getData('text').includes('\n')) {
      event.preventDefault();

      const items = event.clipboardData!.getData('text')!.split('\n').map((x: string) => x.trim()).filter((x: string) => x.length > 0);
      const [header, open]: any = Object.entries(this.filterMenus).find(([h, value]) => value);
      this.list = [...items.map((i: string) => {
        if (open) {
          const headerToFilterOn = this.headers.find((h) => h.value === header);
          const nameToIdMap: { [key: string]: number } = {};
          if (!headerToFilterOn || !headerToFilterOn.allowedFilterValues) {
            return;
          }
          headerToFilterOn.allowedFilterValues.forEach((item: any) => {
            nameToIdMap[item.name] = item.id;
          });
          return {
            id: ++this.nonce,
            value: i,
            internalId: nameToIdMap[i],
            header: headerToFilterOn.value,
            queryKey: headerToFilterOn.queryKey,
          };
        }
      }).filter((v: { id: number; value: string; internalId: number; header: string; queryKey: string; }) => v.value)];

      this.$emit('listUpdated', this.list);
      this.$emit('filtersDirtied', true);
    }
  }

  private compareValues(a: string, b: string) {
    if (a === b) {
      return false;
    }
  }

  private removeFilter(i: any) {
    this.list = this.list.filter((v: any) => v.value !== i.value);
    this.onFilterValuesChange(this.list, []);
    this.$emit('filtersDirtied', true);

    if (!this.list.length) {
      this.$emit('filtersCleared');
    }
  }


  private onBarcodeScan(result: any) {
    this.onFilterValuesChange([...this.list, result.v1], []);
    this.$emit('filtersDirtied', true);
  }
}
